// =================================================================
// Persistence: Session + Audit repositories (IndexedDB) (TODO Task 2.9)
// Routed through db delegation layer for AppLock encryption support.
// =================================================================
import type { AuditEntry, SessionRecord } from '@/types';
import { dbPut, dbGet, dbGetAll, dbDelete } from './db';

class SessionRepo {
  async saveSession(session: SessionRecord): Promise<void> {
    await dbPut('sessions', session);
  }
  async loadSession(id: string): Promise<SessionRecord | undefined> {
    return dbGet<SessionRecord>('sessions', id);
  }
  async listSessions(): Promise<SessionRecord[]> {
    const all = await dbGetAll<SessionRecord>('sessions');
    return all.sort((a, b) => (a.updatedAtISO < b.updatedAtISO ? 1 : -1));
  }
  async deleteSession(id: string): Promise<void> {
    await dbDelete('sessions', id);
  }
}

class AuditRepo {
  async appendEntry(entry: AuditEntry): Promise<void> {
    await dbPut('audit', entry);
  }
  async listEntries(): Promise<AuditEntry[]> {
    const all = await dbGetAll<AuditEntry>('audit');
    return all.sort((a, b) => (a.timestampISO < b.timestampISO ? 1 : -1));
  }
}

export const sessionRepo = new SessionRepo();
export const auditRepo = new AuditRepo();
